module.exports = __webpack_public_path__ + "img/a3.086d8ec2.jpg";